import type { Providers } from '@sparrow-marketing/contracts';

import { axios } from './axios';
import { endpoints } from '../constants';

export type Body = {
  name: string;
  data: {
    data: {
      metric: string;
      label: string;
      value: string;
    }[][];
    headers: {
      label: string;
      metric: string;
    }[];
  };
  type: string;
  businessId: string;
  clientId: string;
};

type Response = {
  accounts: Providers.Accounts.IAccount<any>[];
};

export default {
  async post(body: Body) {
    const { datastoreUploadUrl } = endpoints();

    try {
      const { data } = await axios.post<Response>(
        `${datastoreUploadUrl}`,
        body
      );
      return data;
    } catch (error) {
      throw new Error('Failed to add datasource');
    }
  },
};
